import { selectMenuCss } from '../../../../theme/selectStyles';
import styled, { createGlobalStyle } from 'styled-components';
import Select from 'react-select';
import { StyledButton } from '../../../../globalStyled';

export const ActionSelectMenuGlobal = createGlobalStyle`
  .action-select__menu-portal {
    ${selectMenuCss('action-select')}
    .action-select__menu { min-width:max(100%, 200px); }
  }
`;

export const ActionOptionLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  color: ${({ $active, theme }) =>
    $active ? (theme.isDark ? theme.headerAccent : theme.success) : 'inherit'};
  white-space: nowrap;

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    fill: ${({ $active }) => $active ? 'currentColor' : 'none'};
    stroke: currentColor;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
`;

export const StyledActionSelect = styled(Select)`
  bottom: 0;
  background-color: ${({ theme }) => theme.card};
  width: 120px;
  margin-right: 15px;
  font-size: 13px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 6px;
  min-height: 24px;
  height: 24px;
  @media only screen and (max-width: 768px) {
    width: 95px;
    margin-right: 5px;
  }
  .action-select__control {
    min-height: 24px;
    background-color: transparent;
    border: 0;
    font-weight: 700;
    box-shadow: none;
    color: ${({ theme }) => theme.text};
  }

  .action-select__placeholder {
    font-family: 'Archivo', sans-serif;
    line-height: 20px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0px;
    color: ${({ theme }) => theme.textFaint};
  }
  .action-select__single-value,
  .action-select__input-container {
    color: ${({ theme }) => theme.text};
  }
  .action-select__indicator {
    padding: 2px 8px;
    transition: transform 160ms ease-out;
    svg {
      fill: ${({ theme }) => theme.textFaint};
      width: 12px;
    }
  }
  .action-select__control--menu-is-open .action-select__dropdown-indicator {
    transform: rotate(180deg);
  }
  .action-select__single-value {
    font-weight: normal;
  }

  .action-select__indicator-separator {
    margin-bottom: 4px;
    margin-top: 2px;
    background-color: ${({ theme }) => theme.border};
  }
`;
export const StyledSelectContainer = styled.div`
  width: 100%;
  display: flex;
  bottom: 0;
  flex-direction: row;
  align-items: center;
  height: 40px;
`;
export const StyledTableButton = styled(StyledButton)`
  height: 29px;
  min-width: 120px;
  margin: 0px;
  font-size: 13px;
  text-transform: capitalize;
`;

export const StyledScoutingSpan = styled.span`
  color: #ff4d09 !important;
  border-radius: 5px;
  padding: 0px;
  background: transparent;
  text-decoration: none;
  text-transform: capitalize;
  font-family: 'Archivo', sans-serif;
  line-height: 100%;
  font-weight: 500;
  font-size: 13px;
`;

export const StyledScoutResult = styled.span`
  font-size: 13px;
`;

export const StyledButtonContainer = styled.div`
  margin: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;
